import {
  REGIONS_CLEAR_COUNTRIES,
  REGIONS_FETCH_CATEGORY,
  REGIONS_FETCH_COUNTRIES,
  REGIONS_FETCH_GLOBAL_COUNTRIES,
  REGIONS_FETCH_REGIONS,
  REGIONS_FETCH_STATES
} from "../action-types/regions";

export const initialState = {
  regions: [],
  countries: [],
  states: [],
  statesByCountry: {},
  countriesByRegion: {},
  categoryByRegion: {},
  loading: false,
  globalCountries: [],
};

const mapNameAndDescription = e => ({
  ...e,
  _name: e.name,
  name: e.description,
});

const iso3ToLower = (country) => {
  const countryResult = {
    ...country,
    iso3: country.ISO3.toLowerCase()
  };
  delete countryResult.ISO3;

  return  countryResult;
};

export default function reducer (state = initialState, action): any {
  switch (action.type) {
    case REGIONS_FETCH_REGIONS.REQUEST:
      return {
        ...state,
        loading: true,
        regions: [],
        countries: [],
        states: [],
      };
    case REGIONS_FETCH_STATES.REQUEST:
      return {
        ...state,
        loading: true,
        sates: [],
      };
    case REGIONS_FETCH_REGIONS.SUCCESS:
      return {
        ...state,
        regions: action.payload.data,
        loading: false,
      };
    case REGIONS_FETCH_COUNTRIES.SUCCESS:
      const countries = action.payload.data.map(iso3ToLower);
      return {
        ...state,
        countries,
        countriesByRegion: {
          ...state.countriesByRegion,
          [action.payload.meta.region]: countries,
        },
        loading: false,
      };
    case REGIONS_FETCH_CATEGORY.SUCCESS:
      const { meta, data = {} } = action.payload;
      return {
        ...state,
        categoryByRegion: {
          ...state.categoryByRegion,
          [meta.region]: {
            isParent: Boolean(data.isParent),
            categoryName: data.category?.name,
            subCategoryName: data.subCategory?.name,
          },
        },
        loading: false,
      };
    case REGIONS_FETCH_CATEGORY.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case REGIONS_FETCH_CATEGORY.REJECTED:
      return {
        ...state,
        loading: false,
      };
    case REGIONS_CLEAR_COUNTRIES:
      return {
        ...state,
        countries: [],
      };
    case REGIONS_FETCH_STATES.SUCCESS:
      return {
        ...state,
        loading: false,
        statesByCountry: {
          ...state.statesByCountry,
          [action.payload.meta.country]: action.payload.data.map(
            mapNameAndDescription,
          ),
        },
        states: action.payload.data.map(mapNameAndDescription),
      };
    case REGIONS_FETCH_STATES.REJECTED:
      return {
        ...state,
        loading: false,
        states: [],
      };
    case REGIONS_FETCH_GLOBAL_COUNTRIES.SUCCESS:
      return {
        ...state,
        globalCountries: [...action.payload.data.map(iso3ToLower)],
      };

    default:
      return state;
  }
}
